$(document).ready(() => {
  if (!$('html').hasClass('page-new_faq')) return
  $('[data-faq-gradient-select]').change(function() {
    const elem = $('.custom-faq-gradient-block-menu-wrapper').find(`[data-category="${$(this).val()}"]`)
    if(elem) elem.click();
  })

  $('.custom-faq-gradient-block-content-item-qa-question').each((i, item) => {
    $('.search-elements').append(`<a class="search_link hide" href="#${$(item).parent().attr("id")}"> ${$(item).text()} </a>`)
  })

  $('.search_link').click(function() {
    $($(this).attr('href')).find('.custom-faq-gradient-block-content-item-qa-question').click()
  })

  $('.new-faq-hero_form .place_for_search').on('input', function (e) {
    e.preventDefault();
    const val = this.value.trim().toLowerCase();
    const items = $('.search_link');
    const form = $('.new-faq-hero_form');
    items.removeClass('hide')

    if (val) {
      $('.new-faq-hero_form .button').removeClass('active_button')
      $('.new-faq-hero_form .arrow').addClass('active_button')
      items.each(function () {
        if (!$(this).text().toLowerCase().includes(val))
          $(this).addClass('hide');
      })
      $(form).addClass('active').next().slideDown();
      return
    } 
    $('.new-faq-hero_form .arrow').removeClass('active_button')
    $('.new-faq-hero_form .button').addClass('active_button')
    $(form).removeClass('active').next().slideUp();
  });

  $('.new-faq-hero_form .arrow').click(() => {
    let input = $('.new-faq-hero_form .place_for_search')
    $('.new-faq-hero_form .arrow').removeClass('active_button')
    $('.new-faq-hero_form .button').addClass('active_button')
    input.val('')
  })

  $(document).on('blur', '.place_for_search', function (e) {
    const form = $('.new-faq-hero_form');
    form.removeClass('active').next().slideUp();
  });

  moveSectionsToFaq()
});
